<template>
    <div v-loading="!ready">
        <template v-if="ready">
            <kendo-datasource
			    ref="gridDataSource"
			    :page-size="gridDataSource.pageSize"
			    :schema="gridDataSource.schema"
			    :server-paging="true"
			    :server-sorting="true"
			    :server-filtering="true"
			    :transport-read="gridDataSource.transport.read"
				:transport-parameter-map="gridDataSource.transport.parameterMap"
		    />
		    <kendo-grid
			    ref="grid"
			    :column-menu="false"
			    :column-resize-handle-width="8"
			    :data-source-ref="'gridDataSource'"
			    :filterable="grid.filterable"
			    :groupable="grid.groupable"
			    :pageable="grid.pageable"
			    :reorderable="false"
			    :resizable="true"
                :selectable="'row'"
			    :sortable="true"
                @change="onGridChange"
		    >
			    <kendo-grid-column 
				    field="userName" 
				    title="Username"
                    width="120px"
                    template="<span class='text-link'>#=userName#</span>"
                    :filterable-cell-show-operators="false"
			    />
			    <kendo-grid-column 
				    field="firstName" 
				    title="First name"
                    width="120px"
                    :filterable-cell-show-operators="false"
			    />
                <kendo-grid-column 
				    field="lastName" 
				    title="Last name"
                    width="120px"
                    :filterable-cell-show-operators="false"
			    />
                <kendo-grid-column 
				    field="role" 
				    title="Role"
                    width="120px"
                    :filterable-cell-show-operators="false"
                    :filterable-cell-template="roleFilterTemplate"
                    :template="roleTemplate"
			    />
                <kendo-grid-column 
				    field="emailAddress" 
				    title="Email"
                    width="240px"
                    :filterable-cell-show-operators="false"
                    :filterable-cell-operator="'contains'"
                    :filterable-cell-suggestion-operator="'contains'"
			    /> 
                <kendo-grid-column
                    field="lastLoginOn"
                    title="Last Logged In"
                    width="150px"
                    :filterable-cell-show-operators="false"
                    template="#= (lastLoginOn == null) ? '' : kendo.toString(lastLoginOn, 'MMMM dd, yyyy hh:mm tt') #"
                />
		    </kendo-grid>
        </template>
	</div>
</template>


<script>
	import _ from 'lodash';
    import { AsyncMixin } from 'pdk/mixins';
    import { KendoGridMixin } from '@/mixins';
    import { groups, roles } from '@/services';


	export default {
		name: 'user-list-grid',
        mixins: [AsyncMixin, KendoGridMixin],
        props: {
            locationGroupId: {
                type: String,
                required: true
            }
        },
		data() {
			return {
				grid: {
                    groupable: {
                        enabled: false,
                        showFooter: false
                    },
                    filterable: {
                        mode: 'row',
						extra: false
                    },
                    pageable: {
                        alwaysVisible: true,
                        refresh: true
                    }
                },
                gridDataSource: groups.getUsers_KendoDataSource({
                    locationGroupID: this.locationGroupId
                }),
                roles: undefined
			};
        },
        computed: {
            ready() {
                return this.roles && this.roles.length > 0;
            }
        },
        created() {
            this.async(roles.getRoles())
                .then((rolesList) => {
                    this.roles = rolesList;
                });
        },
        methods: {
            // Grid templates
            roleTemplate(item) {
                const role = _.find(this.roles, (r) => r.locationGroupRoleTypeID == parseInt(item.role));
                const result = role ? role.locationGroupRoleTypeText : item.role;
                return result ? result : '';
            },
            roleFilterTemplate(e) {
                e.element.kendoDropDownList({
                    dataSource: this.roles,
                    valuePrimitive: true,
                    dataTextField: 'locationGroupRoleTypeText',
                    dataValueField: 'locationGroupRoleTypeID',
                    optionLabel: '- All roles -'
                });
            },
            refresh() {
                this.getKendoGridHelper('grid').refresh();
            },

            // Event handlers
            onGridChange(e) {
                const helper = this.getKendoGridHelper(e);
                const item = helper.getSelectedItems()[0];

                this.$emit('change', item);
            }
		}
	};
</script>
